module.exports = __webpack_public_path__ + "static/media/hospital-week-4.39e3708f.jpg";